import { GET } from "../../utils/constants/verbs";
import { put, takeLatest } from "redux-saga/effects";
import requestAPI from "../../helpers/requestHelpers";
import { Types } from "../ducks/athelete";
import urls from "../../utils/constants/urlsAPI";
import { POST } from "../../utils/constants/verbs";
import { cardHash } from "../../helpers/cardHash";
import { cpfMask, heightMask, weightMask, phoneMask, zipCode } from "helpers/maskHelpers";

const formatDate = value => {
  const date = value.split("-");
  return `${date[2]}/${date[1]}/${date[0]}`;
};

function* requestRegisterAthelete({ payload }) {
  try {
    let Obj = {
      event_id: payload.eventId,
      email: payload.email,
      full_name: payload.name,
      card_hash: payload.cardHash,
      payment_method:
        payload.paymentType === "creditCard"
          ? "credit_card"
          : payload.paymentType, /////
      gender: payload.sex,
      birth_date: formatDate(payload.birthday),
      has_european_passport:
        payload.europeanPassport,
      european_passport_number: payload.europeanPassportNumber,
      position_id: payload.position,
      installments: 1,
      weight: weightMask(payload.weight),
      height: heightMask(payload.height),
      document_number: payload.country == "32" ? cpfMask(payload.CPF) : payload.passport,
      document_type: payload.country == "32" ? "cpf" : "passporte",
      telephone: phoneMask(payload.phone),
      responsable_cpf: payload.country == "32" ? cpfMask(payload.CPFResp) || "" : payload.passportResp,
      responsable_telephone: phoneMask(payload.phoneResp) || "",
      responsable_name: payload.name,
      soccer_school_id: payload.soccer_school_id,
      address_attributes: {
        street: payload.address,
        complement: payload.complement,
        number: payload.number,
        neighborhood: payload.neighborhood,
        city_name: payload.city,
        country_id: payload.country,
        zip_code: zipCode(payload.zipCode),
        uf_name: payload.state,
        city_id: 459
      }
    };
    const data = yield requestAPI({
      verb: POST,
      endPoint: urls.subscribe,
      data: Obj
    });
    payload.callback();
    yield put({
      type: Types.ATHELETE_REQUEST_SUCCESS,
      payload: { ...data, scroll: payload.scroll }
    });
  } catch (error) {
    const { data } = error.response || error.message;
    yield put({
      type: Types.ATHELETE_REQUEST_FAIL,
      error: { ...data }
    });
  }
}

export function* watcherSaga() {
  yield takeLatest(Types.ATHELETE_REQUEST, requestRegisterAthelete);
}
